import clsx from "clsx";

export function Fill({ className }: { className?: string }) {
  return <span aria-hidden className={clsx("skeleton-fill", className)} />;
}

export function SkeletonHeading() {
  return (
    <div className="section-heading skeleton-heading">
      <Fill className="skeleton-heading__title" />
      <Fill className="skeleton-heading__action" />
    </div>
  );
}

export function SkeletonSubnav() {
  return (
    <div className="packs-subnav skeleton-subnav">
      <Fill />
      <Fill />
      <Fill />
    </div>
  );
}

export function RowSkeleton({ rows }: { rows: number }) {
  return (
    <div className="skeleton-list">
      {Array.from({ length: rows }, (_, index) => (
        <div className="skeleton-row" key={index}>
          <Fill />
          <Fill />
          <Fill />
        </div>
      ))}
    </div>
  );
}

export function RaceRailSkeleton({ count }: { count: number }) {
  return (
    <div className="race-card-rail skeleton-race-rail">
      {Array.from({ length: count }, (_, index) => (
        <article className="next-race-card skeleton-race-card" key={index}>
          <div className="skeleton-race-card__header">
            <Fill />
            <Fill />
          </div>
          <Fill className="skeleton-line skeleton-line--short" />
          <div className="skeleton-race-card__favourites">
            <Fill />
            <Fill />
            <Fill />
          </div>
          <div className="skeleton-race-card__footer">
            <Fill />
            <Fill />
          </div>
        </article>
      ))}
    </div>
  );
}

export function HorseRailSkeleton({ count }: { count: number }) {
  return (
    <div className="horse-card-rail skeleton-horse-rail">
      {Array.from({ length: count }, (_, index) => (
        <article
          className="discovery-horse-card skeleton-horse-card"
          key={index}
        >
          <Fill className="skeleton-horse-card__portrait" />
          <div>
            <Fill className="skeleton-line skeleton-line--medium" />
            <Fill className="skeleton-line skeleton-line--short" />
            <Fill className="skeleton-line" />
            <Fill className="skeleton-line skeleton-line--medium" />
          </div>
        </article>
      ))}
    </div>
  );
}

export function ScheduleSkeleton() {
  return (
    <section className="panel schedule-matrix skeleton-schedule">
      <div className="skeleton-schedule__times">
        <Fill />
        <Fill />
        <Fill />
        <Fill />
      </div>
      {Array.from({ length: 3 }, (_, index) => (
        <div className="skeleton-schedule__track" key={index}>
          <Fill />
          <div>
            <Fill />
            <Fill />
            <Fill />
            <Fill />
          </div>
        </div>
      ))}
    </section>
  );
}

export function ActivitySkeleton({ count }: { count: number }) {
  return (
    <div className="live-opens-rail skeleton-activity">
      {Array.from({ length: count }, (_, index) => (
        <article key={index}>
          <Fill className="skeleton-activity__portrait" />
          <div>
            <Fill className="skeleton-line skeleton-line--medium" />
            <Fill className="skeleton-line" />
          </div>
          <Fill className="skeleton-line skeleton-line--short" />
        </article>
      ))}
    </div>
  );
}

export function TableSkeleton({ rows }: { rows: number }) {
  return (
    <div className="skeleton-table">
      <div className="skeleton-table__header">
        <Fill />
        <Fill />
        <Fill />
        <Fill />
      </div>
      {Array.from({ length: rows }, (_, index) => (
        <div className="skeleton-table__row" key={index}>
          <Fill className="skeleton-table__avatar" />
          <Fill />
          <Fill />
          <Fill />
        </div>
      ))}
    </div>
  );
}
